import React from 'react';
import { FiMail, FiSend } from 'react-icons/fi';
import './EmailMasterLoader.css';

const EmailMasterLoader = ({ message = "Loading..." }) => {
  return (
    <div className="email-master-loader">
      <div className="loader-container">
        {/* Animated Mail Icon */}
        <div className="mail-icon-container">
          <div className="mail-envelope">
            <FiMail className="mail-icon" />
          </div>
          <div className="mail-send-icon">
            <FiSend className="send-icon" />
          </div>
        </div>
        
        {/* Loading Text */}
        <div className="loader-text">
          <h3 className="loader-title">EmailMaster</h3>
          <p className="loader-message">{message}</p>
        </div>
        
        {/* Animated Dots */}
        <div className="loading-dots">
          <span className="dot"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
      </div>
    </div>
  );
};

export default EmailMasterLoader;
